import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeakerGroupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speaker_group"}/>
}
